import React from 'react';

const Spinner = ({ color = 'border-purple-500' }) => (
    <div className={`animate-spin rounded-full h-6 w-6 border-b-2 ${color}`}></div>
);

export default Spinner;